import React from "react";
import "./assets/css/style.css";


export default function PageNotFound() {
  return (
    <div className="bg-dark text-light">
      <h1>Page not found</h1>
    </div>
  );
}
